<template>
  <div id="DataUpdateRequestMenu">
    <div>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            >
          </v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="DataUpdateRequest"
          :search="search" 
          class="pf-data-table"
          :pagination.sync="pagination" 
        >
          <template v-slot:items="props">
            <tr>
                <td>{{ props.item.account.name }}</td>
                <td>{{ props.item.account.human[0].user.username }}</td>
                <td>{{ props.item.account.ppn }}</td>
                <td>{{ formatDateString(props.item.updatedAt, 'MM/DD/YYYY') }}</td>
                <td>{{ props.item.status }}
                    <!-- <v-select
                        :disabled="['Pending', 'Approval'].indexOf(props.item.status) === -1"
                        :value="props.item.status"
                        :items="['Approved', 'Pending', 'Approval', 'Completed', 'Rejected']"
                        height="30px"
                        @change="statusUpdate(props.item, $event)"
                    ></v-select> -->
                </td>
                <td>
                  <v-btn class="pf-btn pf-btn-save" @click="statusUpdate(props.item)" :disabled="['Approved', 'Completed'].indexOf(props.item.status) > -1">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Approve</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-cancel" @click="statusUpdate(props.item, true)" :disabled="['Approved', 'Completed'].indexOf(props.item.status) > -1">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Reject</div>
                  </v-btn>
                </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
/* global session store config */
import swal from 'sweetalert2';
import { getCollection, update, formatDate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Family', value: 'account.name', align: 'left' },
      { text: 'Username', value: 'account.human[0].user.username', align: 'left' },
      { text: 'PPN', value: 'account.ppn', align: 'left' },
      { text: 'Updated At', value: 'updatedAt' },
      { text: 'Status', value: 'status' },
    //   { text: '', sortable: false },
    ],
    pagination: {
      sortBy: '',
      rowsPerPage: config.dom.rowsPerPage,
    },
    rejectReason: null
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency']),

    DataUpdateRequest: {
      set (value) {
        store.commit('setDataUpdateRequest', value);
      },
      get () {
        return store.state.DataUpdateRequest;
      }
    }
  },
  created () {
    this.getRequests();
  },
  methods: {
    async getRequests () {
      let attributes = 'account,type,old_value,new_value,status,updatedAt,_id';
      let populate = [{ path: 'account', populate: { path: 'human', select: '_id user', populate: { path: 'user', select: 'username' }}}];
      let where = { type: 'EnableMenuBack', status: { $nin: ['Approved', 'Completed'] }};
      let { error, data } = await getCollection('DataUpdateRequest', true, 0, populate, where, attributes, null, { createdAt: -1 });
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the change requests'
        };
      } else {
        this.DataUpdateRequest = data;
      }
    },
    async statusUpdate (item, isReject = false) {
      if (['Approved', 'Completed'].indexOf(item.status) === -1) {
        let currentStatus = item.status;
        item.status = currentStatus === 'Pending' ? 'Approved' : 'Completed';
        if (isReject) {
          item.status = 'Rejected';
          this.rejectReason = null;
          swal.fire({
            title: 'Add Reason',
            text: 'Please add the reason to reject the request',
            input: 'text',
            inputValidator: (value) => {
              if (!value) {
                return 'Please add a reason to submit!';
              }
            },
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Submit'
          }).then((result) => {
            if (result.value) {
              (async () => {
                this.rejectReason = result.value;
                await this.submitStatusUpdate(item);
              })();
            } else {
              return;
            }
          });
        } else {
          await this.submitStatusUpdate(item);
        }
      }
    },
    async submitStatusUpdate (item) {
      let updateItem = JSON.parse(JSON.stringify(item));
      let itemIndex = this.DataUpdateRequest.indexOf(item);
      let updateId = this.DataUpdateRequest[itemIndex].id;
      updateItem.account = updateItem.account.id;
      updateItem.update_from = 'status';
      if (this.rejectReason) {
        updateItem.description = this.rejectReason;
      }
      updateItem.senderHuman = this.Agency.human;
      
      let { error, data, status } = await update('DataUpdateRequest', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update the request, ' + error,
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      } else {
        swal.fire({
          type: 'success',
          title: `The selected request was ${data.status.toLowerCase()}`,
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {}
        });
      }
    },
    formatDateString (date, format) {
      return formatDate(date, format);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/EditRequests/enableMenu.vue